import { State, Action, StateContext, Store } from "@ngxs/store";
import { patch } from "@ngxs/store/operators";
import { Injectable } from "@angular/core";
import { tap } from "rxjs/operators";
import {
  QuotePolicySearchService,
  DashboardSearchRequest,
  PolicyDownloadService
} from "@tmhcc/data-service";
import { 
  DashboardGridDwld,
  policyDetail
} from "@tmhcc/models";
import { DashboardDataDwld } from "./dashbard.actions";

export interface DashboardStoreDwld {  
  dwldPolicyDataList: policyDetail[];  
}
//==
@State<DashboardStoreDwld>({
  name: "DwldDashboard",
  defaults: {
    dwldPolicyDataList: []
  }
})

@Injectable()
export class DashboardStateDwld {
  constructor(
    private policyDownloadService: PolicyDownloadService,
    private store: Store
  ) {}

  @Action(DashboardDataDwld)
  getDwldDashboardData(
    ctx: StateContext<DashboardStoreDwld>,
    {searchType, dwldDashboardSearchRequest }: DashboardDataDwld
  ) {
    return this.policyDownloadService
      .getDwldPolicyDataMock(searchType,dwldDashboardSearchRequest)
      .pipe(
        tap((data: DashboardGridDwld) => {
          const state = ctx.getState();
          ctx.setState({
            ...state,            
            dwldPolicyDataList: [...data.policyDetail]
          });
        })
      );
  } 
}

